<section class="map-page" aria-label="Global support map">
    <header class="map-page__header">
        <h1>Global Support Map</h1>
        <p>
            Explore journeys shared from around the world and see where support is being sent.
            Click on markers to view individual stories and notes.
        </p>

        <div class="layer-toggle" role="tablist" aria-label="Map layers">
            <button
                type="button"
                class="layer-toggle__button"
                [class.is-active]="activeLayer() === 'journeys'"
                (click)="setLayer('journeys')">
                <span class="layer-toggle__dot layer-toggle__dot--journeys"></span>
                Journeys
                <span class="layer-toggle__count">({{ journeyCount() }})</span>
            </button>

            <button
                type="button"
                class="layer-toggle__button"
                [class.is-active]="activeLayer() === 'support'"
                (click)="setLayer('support')">
                <span class="layer-toggle__dot layer-toggle__dot--support"></span>
                Support
                <span class="layer-toggle__count">({{ supportCount() }})</span>
            </button>
        </div>

        <p class="map-page__loading" *ngIf="!mapReady()">Loading map...</p>
    </header>

    <div class="map-shell">
        <div #map class="map-canvas" [class.map-canvas--loading]="!mapReady()"></div>
    </div>
</section>
